/*
 * The per-viewer sidebar collapse preference (F5-b FR-7 / AC-7).
 *
 * The flag is `collapsed`; the default is EXPANDED (`false`). Both read and write are wrapped so a
 * private-mode / disabled-storage / quota failure degrades to the default instead of throwing — the
 * in-memory layout state still drives the current session, the choice simply is not remembered.
 *
 * Precedence note (F5-b WI-1.1 plan Decision 6): this preference only takes effect at `bp/desktop`. At `bp/laptop`
 * the frame is forced icon-only and at `bp/tablet` it becomes an overlay, so `AppLayout` reads this
 * flag but the responsive tier can override the effective mode.
 */
const KEY = 'et.sidebar.collapsed';

export const sidebarPreference = {
    /** The stored collapse flag, or the default (expanded → `false`) when storage is unreadable. */
    read(): boolean {
        try {
            return globalThis.localStorage?.getItem(KEY) === 'true';
        } catch {
            // Private mode or a storage-access exception — fall back to the expanded default.
            return false;
        }
    },
    /** Persist the collapse flag; a storage failure is swallowed so the toggle never throws. */
    write(collapsed: boolean): void {
        try {
            globalThis.localStorage?.setItem(KEY, collapsed ? 'true' : 'false');
        } catch {
            // Private mode or a quota exception — the session keeps its in-memory state (F5-b AC-7).
        }
    },
} as const;
